var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":"https://explicae.com.br/app/landings/img/loader.gif"}})])
}]

export { render, staticRenderFns }